import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Menubar } from 'primereact/menubar';
import { useNavigate } from 'react-router-dom';
import { Toolbar } from 'primereact/toolbar';
import { SplitButton } from 'primereact/splitbutton';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Avatar } from 'primereact/avatar';
import { TabMenu } from 'primereact/tabmenu';
import UserIcon from './UserIcon'
import { useKeycloak } from "@react-keycloak/web";


function CommonNav() {
    const [email, setEmail] = useState('');
    const [value, setValue] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const { keycloak } = useKeycloak();
    const isPowerUser = keycloak.realmAccess.roles.includes("poweruser");
    const isTeacher = keycloak.realmAccess.roles.includes("teacher");
    console.log("isPowerUser");
    console.log(isPowerUser);

    const navigate = useNavigate();

//        {
//            label: 'Home',
//            icon: 'pi pi-home',
//            command: () => navigate('/requestsub')
//        },


//        {
//            label: 'View Open Jobs',
//            icon: 'pi pi-check-square',
//            command: () => navigate('/viewSubRequest?substitute_job_id=1&sub_id=1')
//        },


    const items = [
        ...(isPowerUser || isTeacher
            ? [{ label: 'Home', icon: 'pi pi-home', command: () => navigate('/requestsub') },]
            : []
        ),
        ...(!isPowerUser && !isTeacher
            ? [{ label: 'Home Sub', icon: 'pi pi-home', command: () => navigate('/viewMyJobs') },]
            : []
        ),


        // Only show this if user is admin
        ...(isPowerUser
            ? [{ label: 'Manage Substitutes', icon: 'pi pi-user-edit', command: () => navigate('/subform')},
                       { label: 'Manage Groups', icon: 'pi pi-star', command: () => navigate('/groups')},]
            : []
        ),
        // Only show this if user is admin or a teacher
        ...(isPowerUser || isTeacher
            ? [{ label: 'Schedule Substitute', icon: 'pi pi-calendar-plus', command: () => navigate('/requestsub') },]
            : []
        ),
        ...(isPowerUser || isTeacher
            ? [{ label: 'View My Sub Requests', icon: 'pi pi-check-square', command: () => navigate('/viewTeacherJobs') },]
            : []
        ),
        ...(!isPowerUser && !isTeacher
            ? [{ label: 'View My Jobs', icon: 'pi pi-check-square', command: () => navigate('/viewMyJobs') },]
            : []
        ),
        {
            label: 'Terms of Service',
            icon: 'pi pi-star',
            command: () => navigate('/termsofservice')
        },

    ];
    const isLoggedInUser = true;

    const startContent = (
        <React.Fragment>
        </React.Fragment>
    );

    const centerContent = (
        <React.Fragment>
            <TabMenu model={items} />
        </React.Fragment>
    );

    const endContent = (
        <React.Fragment>
            <UserIcon isLoggedIn={isLoggedInUser} />
        </React.Fragment>
    );
    return (
        <div className="card">
            <Menubar start={startContent} model={items} end={endContent} />
        </div>
    );
}

export default CommonNav;